import { type CollaborationContextInfo } from './types';

export function buildCollaborationContextFields(
	collaborationContextInfo: CollaborationContextInfo,
): any {
	return {
		collaborationContextAri: collaborationContextInfo.collaborationContextAri,
	};
}
